module.exports = __webpack_public_path__ + "static/news-3-b119fc04f56f29027fbae53dfc784e16.png";